import { Form } from 'antd';

import ToggleRadio from '@/components/Common/ToggleRadio';

import { SCRAPER_REQ_FIELD_KEY } from '../../configs/scraper-field-map/field-const';

export const AllOptionsField = (props: { required?: boolean }) => {
  const { required = false } = props;
  return (
    <>
      <Form.Item
        name={SCRAPER_REQ_FIELD_KEY.ALL_OPTIONS}
        hidden
        required={required}
      >
        <input />
      </Form.Item>
      <Form.Item label="All Options" shouldUpdate required={required}>
        {({ getFieldValue, setFieldValue }) => {
          const currentExactMatch: boolean =
            getFieldValue(SCRAPER_REQ_FIELD_KEY.ALL_OPTIONS) || false;
          return (
            <ToggleRadio
              status={currentExactMatch}
              onChange={(value) => {
                setFieldValue(SCRAPER_REQ_FIELD_KEY.ALL_OPTIONS, value);
              }}
            />
          );
        }}
      </Form.Item>
    </>
  );
};
